export default "__VITE_ASSET__LuQZMLFj__"